
export default (t) => [
  {
    text: t('Expense Date'),
    value: 'expense_date',
    sortable: true,
    width: 160,
    togglable: true
  },
  {
    text: t('Category'),
    value: 'category',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Description'),
    value: 'message',
    sortable: false,
    togglable: true
  },
  {
    text: t('Reference No.'),
    value: 'reference_no',
    sortable: false,
    width: 140,
    togglable: true
  },
  {
    text: t('Payee'),
    value: 'payee',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Branch'),
    value: 'branch',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Amount'),
    value: 'amount',
    sortable: true,
    width: 140,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 150
  },
];
